import React, { Component } from "react";
import { Button, Switch, message, Modal, Form, InputNumber, Input, Icon, Row, Col } from 'antd';
import QRCode from 'qrcode.react';//引入生成二维码的库
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import NHFormItem from '../../common/NHFormItem';
import { NHConfirm } from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './edit-form/EditForm.js';
import ViewForm from './ViewForm.js';
import StudentMng from './student-mng/index';
import css from './index.css';
import CopyForm from './CopyForm';
import { hasAuth } from "../../../utils/NHCore";

const confirm = Modal.confirm;
const basicUrl = '/lcpz/';

/**
 * 流程配置列表
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-07 09:29:54
 * Version: 1.0
 * Modify log:
 */
class IndexComponet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                assignFlag: false,
                viewFlag: false,
                copyFlag: false,
            },
            tempData: {},//当前操作的行数据
            showOperationBtn: false, //是否显示删除操纵按钮
            statusList: [],//状态列表
            showOperationBtnEwm: false, //是否显示设置二维码按钮
            pkid: '',//报到二维码的值
            dwkg: false,//定位报到开关
            visibleEwm: false,//是否显示设置二维码
            lcdy:{}
        };
    }

    componentWillMount() {
        this.statusload();
    }
    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }

    //复制流程按钮点击事件
    handleCopyBtnClick = () => {
        this.setCurrentPageShow('copyFlag');
    }

    //修改流程状态
    handleStatusChange = (pkid, value) => {
        NHFetch(basicUrl + 'updateStatus', 'POST', { pkid: pkid, zt: value ? '1' : '0' })
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    }

    //管理学生
    handleStuMngBtnClick = (record) => {
        this.setState({ tempData: record });
        this.setCurrentPageShow('assignFlag');
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({ formInitData: res.data });
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }

    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({ tempData: record });
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({ formInitData: res.data });
                    this.setCurrentPageShow('viewFlag');
                }
            })
    }
    //选择行后显示删除、设置二维码操作按钮
    rowSelectionChange = (selectedRowKeys) => {
       
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })//显示删除按钮
            if (selectedRowKeys.length == 1) {
                this.setState({
                    showOperationBtnEwm: true,
                })//显示设置二维码按钮
            } else {
                this.setState({
                    showOperationBtnEwm: false,
                })//隐藏设置二维码按钮
            }

        } else {
            this.setState({
                showOperationBtn: false,
                showOperationBtnEwm: false,
            })
        }
    }
    //打开设置二维码
    handleEwmBtnClick = () => {
        const selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;//获取流程数据
        const pkid = selectedRowKeys[0]//截取数据pkid
        let data={"pkid":pkid}
        NHFetch('/lcpz/getLcdyById', 'POST', data)
                    .then(res => {
                        if (res&&res.data) {
                           
                            this.setState({
                                lcdy:res.data
                            })
                            if(res.data.SFKQDW=="1"){
                                this.setState({
                                    dwkg:true
                                })
                            }
                            
                        }
                    })

        this.setState({
            pkid: pkid,
            visibleEwm: true
        });
    }
    // 关闭模态框
    handleCancel = () => {
        this.props.form.resetFields();  //这是重置为默认值
        this.setState({
            pkid: '',
            dwkg: false,
            visibleEwm: false
        });
    };
    handleChange = (val) => {
        this.setState({
            dwkg: val,
            lcdy:{}
        })

    }
    // 生成二维码
    handleSubmit = _ => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                NHFetch('/lcpz/updateLcdyById', 'POST', values)
                    .then(res => {
                        if (res) {
                          
                            if(res.data>=1){
                                message.success("保存成功")
                            }
                            else{
                                message.warn("保存失败")
                            }
                            
                        }
                    })
                this.props.form.resetFields();  //这是重置为默认值
                this.setState({
                    pkid: '',
                    dwkg: false,
                    visibleEwm: false
                });
            }
        });
    }
    // 下载二维码
    changeCanvasToPic = () => {
        // console.log('测试:', 123)
        const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
        const img = new Image();//创建图片对象
        img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
        const downLink = document.getElementById('down_link');
        downLink.href = img.src;
        downLink.download = '报到二维码'; // 图片name 
    };
    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data) {
                        message.success("删除操作成功！");
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    }

    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch(basicUrl + 'insert', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data) {
                            message.success("新增流程配置成功！");
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                        }
                    }
                })
        });
    }

    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.formInitData.PKID;
            NHFetch(basicUrl + 'update', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data) {
                            message.success("修改流程配置成功！");
                            this.setCurrentPageShow('tableFlag');
                            this.refs.nhTable.filterTableData();
                        }
                    }
                })
        });
    }

    //复制保存方法
    handleSaveCopy = () => {
        this.refs.nhCopyForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let pkids = formData.pkids;
            let copynd = formData.copynd;
            let scnd = formData.scnd;
            if (pkids && pkids.length > 0) {
                if (Number.parseInt(scnd) === copynd) {
                    message.error("已存在当前年度流程，不允许复制！");
                } else {
                    NHFetch('/lcpz/operateCopyLc', 'POST', formData)
                        .then(res => {
                            if (res) {
                                if (res.data) {
                                    message.success("复制流程成功！");
                                    this.setCurrentPageShow('tableFlag');
                                    this.refs.nhTable.filterTableData();
                                }
                            }
                        })
                }
            } else {
                message.warning("请选择需要复制的流程！");
            }
        })
    }

    statusload = () => {
        NHFetch("/proData/selectDataList", "get", 'sign=dmk_XTGL_ZT')
            .then(res => {
                if (res) {
                    if (res.data) {
                        let t = '';
                        let f = '';
                        let statusName = [];
                        for (let i = 0; i < res.data.length; i++) {
                            let d = res.data[i];
                            if (d.VALUE == 0) {
                                f = d.LABEL;
                            }
                            if (d.VALUE == 1) {
                                t = d.LABEL;
                            }
                        }
                        statusName[0] = f;
                        statusName[1] = t;
                        this.setState({
                            statusList: statusName
                        })
                    }
                }
            });
    };

    render() {
        const { form } = this.props;
        const lcdy=this.state.lcdy;
        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '年度',
                width: '60px',
                dataIndex: 'ND',
                searchType: "input"
            }, {
                title: '流程名称',
                width: '150px',
                dataIndex: 'LCMC',
                search: 'input',
                searchType: "input"
            }, {
                title: '包含环节',
                width: '200px',
                dataIndex: 'HJMC',
                searchType: "input"
            }, {
                title: '已分配学生数',
                width: '120px',
                dataIndex: 'YFPXSS',
                searchType: "input"
            }, {
                title: '流程状态',
                width: '100px',
                dataIndex: 'ZTMC',
                render: (text, record, index) => {
                    let status = record.ZT == '1' ? true : false;
                    return (
                        hasAuth('zhxg_yxgl_lcgl_lcpz:status') ?
                            <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]} checked={status} onChange={value => this.handleStatusChange(record.PKID, value)} />
                            : <Switch checkedChildren={this.state.statusList[1]} unCheckedChildren={this.state.statusList[0]} checked={status} disabled={true}
                                onChange={value => this.handleStatusChange(record.PKID, value)} />
                    );
                },
                searchType: "select"
            }
        ];

        //行内操作
        const action = [
            { title: '管理学生', onClick: this.handleStuMngBtnClick, auth: 'zhxg_yxgl_lcgl_lcpz:manage' },
            { title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxgl_lcgl_lcpz:detail' },
            { title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_lcgl_lcpz:update' },
            { title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_lcgl_lcpz:delete' }
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none', height: getSize().windowH - 123 }}>
                    <NHTable ref="nhTable"
                        rowKey={record => record.PKID}
                        sign={'zhxg_yxxt_lcgl_lcpz_queryPage'}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}
                    >
                        {
                            hasAuth('zhxg_yxgl_lcgl_lcpz:add') ?
                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_lcgl_lcpz:copy') ?
                                <Button type="primary" ghost style={{ marginLeft: 10 }}
                                    onClick={this.handleCopyBtnClick}>复制流程</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_lcgl_lcpz:delete') ?
                                <Button type="danger" ghost style={{
                                    marginLeft: 10,
                                    display: this.state.showOperationBtn ? undefined : 'none'
                                }}
                                    onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_lcgl_lcpz:set_ewm') ?
                                <Button type="primary" ghost style={{
                                    marginLeft: 10,
                                    display: this.state.showOperationBtnEwm ? undefined : 'none'
                                }}
                                    onClick={this.handleEwmBtnClick}>设置报到二维码</Button>
                                : null
                        }
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                    title="新增流程配置"
                    visible={this.state.frameVisibleMap.addFlag}
                    footer={null}
                    onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" onFinish={this.handleCloseFrame} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                    title="修改流程配置"
                    visible={this.state.frameVisibleMap.updateFlag}
                    footer={null}
                    onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhAssignModal"
                    title={this.state.tempData.LCMC + '—管理学生'}
                    visible={this.state.frameVisibleMap.assignFlag}
                    footer={null}
                    onCancel={this.handleCloseFrame}
                >
                    <StudentMng ref="nhStudentMngForm" initFormData={this.state.tempData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                    visible={this.state.frameVisibleMap.viewFlag}
                    title={this.state.tempData.ND + '—' + this.state.tempData.LCMC + '—配置详情'}
                    footer={null}
                    onCancel={this.handleCloseFrame}
                >
                    <ViewForm initFormData={this.state.formInitData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhCopyModal"
                    title={'复制流程'}
                    visible={this.state.frameVisibleMap.copyFlag}
                    onOk={this.handleSaveCopy}
                    onCancel={this.handleCloseFrame}
                >
                    <CopyForm ref="nhCopyForm" />
                </NHContainerFrame>
                <Modal
                    width={570}
                    visible={this.state.visibleEwm}
                    title="设置报到二维码"
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="handle" type="primary" onClick={this.handleSubmit}>保存</Button>
                    ]}
                >
                    <Row>
                        <Col span={6}>
                            <a id="down_link" download onClick={this.changeCanvasToPic} title="点击下载">
                                <QRCode
                                    id="qrCode"
                                    value={this.state.pkid}  //value参数为生成二维码的值
                                    // imageSettings={this.state.qrImageSettings}//设置二维码logo
                                    size={150} //二维码的宽高尺寸
                                    fgColor="#000000"  //二维码的颜色
                                />
                                <span style={{ width: '150px', display: 'block', textAlign: 'center', marginTop: '6px' }}><Icon type="download" />下载</span>
                            </a>
                        </Col>
                        <Col span={15} offset={2} style={{ marginTop: '-15px' }}>
                            <Form hideRequiredMark >
                                <NHFormItem id={'dwkg'} label={'定位报到'} valuePropName={'checked'} initialValue={this.state.dwkg} form={form} required>
                                    <Switch
                                        checkedChildren={<Icon type="check" />}
                                        unCheckedChildren={<Icon type="close" />}
                                        onChange={(val) => { this.handleChange(val) }}
                                    />
                                </NHFormItem>
                                    <NHFormItem id={'pkid'} label={''} initialValue={this.state.pkid} form={form} required >
                                        <InputNumber style={{display:'none'}} />
                                    </NHFormItem>

                                {this.state.dwkg ?
                                    (
                                        <div>
                                            <NHFormItem id={'jd'} label={'经度'} initialValue={lcdy.SZDJD} form={form} required>
                                                <InputNumber style={{ width: '150px' }} />
                                            </NHFormItem>
                                            <NHFormItem id={'wd'} label={'纬度'} initialValue={lcdy.SZDWD} form={form} required>
                                                <InputNumber style={{ width: '150px' }} />
                                            </NHFormItem>
                                            <NHFormItem id={'bjfw'} label={'扩展半径'} initialValue={lcdy.DWFW} form={form} required>
                                                <InputNumber placeholder={'目标经纬度扩展半径范围（米）'} style={{ width: '150px' }} />
                                            </NHFormItem>
                                        </div>
                                    ) : null}

                            </Form>
                        </Col>
                    </Row>
                </Modal>
            </div >
        );
    }
}

// export default IndexComponet;
const IndexForm = Form.create()(IndexComponet);
export default IndexForm;



// WEBPACK FOOTER //
// ./components/lcgl/lcpz/index.js